import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/rfqs'
import Component from 'components/Rfqs'

export default createListViewContainer({ actions, selectors: selectors.rfqs })(Component)
